import type { Messages } from '../types';

export const work = {
  practiceTitle: 'Latihan',
  tabChapters: 'Baharu',
  tabAssigned: 'Diberi',
  chapterCount: '{n} bab',
  noPractices: 'Tiada kerja rumah lagi',
  noPracticesBody: 'Beri kerja rumah dari tab Baharu untuk bermula.',
  syllabusFieldLabel: 'Silibus',
  levelFieldLabel: 'Tahap',
  chooseSyllabus: 'Pilih silibus',
  chooseLevel: 'Pilih tahap',
  railSummaryTitle: 'Ringkasan kerja rumah',
  railSummaryHint: 'Ketik seorang anak untuk buka tab Diberi bagi anak itu.',
  nDone: '{n} selesai',
  assignedToN: 'Diberi kepada {n} anak',
  finishedThis: '{studentName} telah siapkan ini pada {date}',
  finishedThisNoDate: '{studentName} telah siapkan ini',
  workingOnThis: '{studentName} sedang membuat ini',
  assignedToOn: 'Diberi kepada {studentName} · {date}',
  downloading: 'Memuat turun…',
  download: 'Muat turun',
  assignedCount: '{n} diberi',
  nInProgress: '{n} sedang dibuat',
  allDone: 'semua selesai',
  assignAgain: 'Beri semula',
  childFieldLabel: 'Anak',
  chooseChild: 'Pilih anak',
  allChildren: 'Semua anak',
  noLongerLinked: 'Tidak lagi dipautkan',
  statusFieldLabel: 'Status',
  chooseStatus: 'Pilih status',
  allStatuses: 'Semua status',
  noAssignedMatches: 'Tiada kerja rumah sepadan dengan penapis ini.',
  today: 'Hari ini',
  yesterday: 'Semalam',
  daysAgo: '{n} hari lalu',
  weeksAgo: '{n} minggu lalu',

  assignedTimes: 'Diberi {n} kali',

  levelLabel: {
    'Lower secondary': 'Menengah rendah',
    'Upper secondary': 'Menengah atas',
  },

  examTitle: 'Peperiksaan',
  allYears: 'Semua tahun',
  paperCount: '{n} kertas',
  papersOnTheWay: 'Kertas {syllabus} akan menyusul',
  noPapersYet: 'Tiada kertas lagi',
  stillAddingThem: 'Kami masih menambahnya. Cuba {others} sementara itu.',
  noPapersFrom: 'Tiada kertas {syllabus} dari {year}.',
  noPapersMatchFilters: 'Tiada kertas {syllabus} sepadan dengan penapis ini.',
  questionCount: '{n} soalan',
  yearFieldLabel: 'Tahun',
  chooseYear: 'Pilih tahun',
  paperTypeFieldLabel: 'Jenis kertas',
  choosePaperType: 'Pilih jenis kertas',
  allPaperTypes: 'Semua jenis',
  // CORE/EXTENDED are Cambridge tier names and stay untranslated.
  paperTypeLabel:
    '{tag, select, TRIAL {Percubaan} PAST {Kertas lepas} CORE {Core} EXTENDED {Extended} other {{tag}}}',

  examRailTitle: 'Tapis ikut anak',
  examRailHint: 'Ketik seorang anak untuk tukar ke silibus mereka.',

  downloadTitle: 'Muat turun',
  chooseDownloadLanguage: 'Pilih bahasa muat turun',

  assignTitle: 'Beri {chapterTitle}',
  chooseWho: 'Pilih siapa yang hendak diberi',
  couldNotAssignEveryone: 'Tidak dapat memberi kepada semua',
  noLinkedChildren:
    'Anda belum mempunyai anak yang berhubung — hubungkan seorang anak dari tab Anak dahulu.',
  aChild: 'seorang anak',
  aChildCapitalised: 'Seorang anak',
  retry: 'Cuba lagi',
  alreadyAssigned: 'Sudah diberi · {date}',
  doneAssignAgain: 'Siap {date} · beri semula',
  assigning: 'Memberi…',
  assignToCount: 'Beri kepada {n} anak',
  toastAssignedTo: 'Diberi kepada {names}',
  errCouldNotAssign: 'Tidak dapat memberi bab ini.',
  and: 'dan',

  print: {
    tagline: 'Tutor Matematik AI Anda',
    assignedTo: 'Diberi kepada {studentName}',
    languageLabel: 'Bahasa Melayu',
    questionCount: '{n} soalan',
    questionCountWithTime: '{n} soalan · {time}',
    fieldName: 'Nama',
    fieldSchool: 'Sekolah',
    fieldClass: 'Kelas',
    scanToAskLine1: 'Imbas untuk tanya',
    scanToAskLine2: 'Tupai AI',
    askTupai: 'Tanya Tupai',
  },
} as const satisfies Messages['work'];
